export const registerDevMenu = () => null
